import React, { createContext, ReactNode, useContext, useState } from "react";

// User role types
type UserRole = "public" | "user" | "admin";

interface AuthContextType {
  userRole: UserRole;
  setUserRole: (role: UserRole) => void;
  isAuthenticated: boolean;
  login: (role: UserRole) => void;
  logout: () => void;
}

// Default context value
const AuthContext = createContext<AuthContextType | null>(null);

// Auth Provider component
export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [userRole, setUserRole] = useState<UserRole>("public");
  const isAuthenticated = userRole !== "public";

  const login = (role: UserRole) => setUserRole(role);
  const logout = () => setUserRole("public");

  return (
    <AuthContext.Provider value={{ userRole, setUserRole, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook for using auth context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth must be used within an AuthProvider");
  }
  return context;
};